import {FavoritesState} from "@service/store/types/FavoritesState";
import {repositories} from "@service/api/Repositories";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";

export const state: FavoritesState = {
    list: {},
    listIsOpened: false,
    unreadedItems: [],
    repository: repositories.get(RepositoryFabric.FAVORITE),
    observer: null
}
